// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperContainer-cls1_kHN","cls2":"PaperContainer-cls2_1q6 PaperContainer-cls1_kHN"};